/**
 * The Transparent Print admin page's entry: the label the admin page list
 * shows for it, its route, and one sentence on what it is for. The admin
 * routes read its path, and the admin page list (`adminPages.ts`) reads all
 * three. It sits apart from the page so the page list reads it without
 * importing the page.
 */
export const transparentPrintBackgroundPageEntry = {
  title: 'Transparent Print',
  path: '/admin/transparent-print',
  description:
    'Choose the MDL products whose final PDFs print with no white background, for UV printing on dark products such as urns.',
} as const
